// Copyright ©️ 2026 eVolve MEP, LLC

import type { NavOption } from 'app/Layout/NavBar/globalNavigationMenu';
import { StyledNavLink } from 'app/Layout/NavBar/NavBarContent/StyledNavLink';
import { useAppShell } from 'app/Layout/NavBar/useAppShell';
import { useEvolveNavigate } from 'components/Mantine/Navigation/useEvolveNavigate';

type Props = {
  item: NavOption;
  withLabel: boolean;
  onClick?: () => void;
  active?: boolean;
};

export const NavItem = ({ item, withLabel, onClick, active }: Props) => {
  const navigate = useEvolveNavigate('', true);
  const { closeMobileNav } = useAppShell();
  const handleClick = () => {
    onClick?.();
    closeMobileNav();
    void navigate(item.route);
  };

  return <StyledNavLink label={item.label} onClick={handleClick} active={active} withLabel={withLabel} />;
};
